import { Checkbox, Typography } from 'antd'
import { useVersionAwareDrilldownPanelData } from 'features/drilldown/data/DrilldownPanelDataContext'
import _ from 'lodash'
import { FC, useCallback } from 'react'
import styled from 'styled-components'

import { CountsPanelData, useCountConfigs } from './DrilldownCountsView'

const SettingsViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const EnabledCountViewRow = styled.div`
  display: flex;
  gap: 1rem;
`

const { Title } = Typography

export const DrilldownCountsSettingsView: FC = () => {
  const {
    panelData: { activeCountTypes },
    setPanelData,
  } = useVersionAwareDrilldownPanelData<CountsPanelData>()

  const handleCheck = useCallback(
    (countType: string, checked: boolean) => {
      setPanelData((prev) => {
        const newActiveCountTypes = checked
          ? _.uniq([...prev.activeCountTypes, countType])
          : prev.activeCountTypes.filter((t) => countType !== t)
        return {
          ...prev,
          activeCountTypes: newActiveCountTypes,
        }
      })
    },
    [setPanelData]
  )

  const options = useCountConfigs()

  return (
    <>
      <Title level={2}>Show counts:</Title>
      <SettingsViewContainer>
        <div style={{ paddingLeft: '1.5rem' }}>
          {Object.entries(options).map(([, countConfig]) => (
            <EnabledCountViewRow key={countConfig.countType}>
              <Checkbox
                checked={activeCountTypes.includes(countConfig.countType)}
                onChange={(e) =>
                  handleCheck(countConfig.countType, e.target.checked)
                }>
                {countConfig.title}
              </Checkbox>
            </EnabledCountViewRow>
          ))}
        </div>
      </SettingsViewContainer>
    </>
  )
}
